import React from 'react';
import { useTranslation } from 'react-i18next';
import { QBox, QFlex } from '@qualio/ui-components';
import TasksCount from './TasksCount';

type TaskStepMetadataProps = {
  openCount: number;
  doneCount: number;
  closedCount: number;
};

const TaskStepMetadata: React.FC<TaskStepMetadataProps> = ({ openCount, doneCount, closedCount }) => {
  const { t } = useTranslation();
  const total = openCount + doneCount + closedCount;
  const doneLabel = t('common.labels.completed');
  const closedLabel = t('common.labels.canceled');

  return (
    <QBox h="70px" borderColor="gray.200" borderBottomWidth="1px">
      <QFlex h="100%" ml={4} direction="row" align="center">
        <TasksCount label={t('common.labels.total')} count={total} />
        <TasksCount label={t('common.labels.open')} count={openCount} />
        <TasksCount label={doneLabel} count={doneCount} />
        <TasksCount label={closedLabel} count={closedCount} />
      </QFlex>
    </QBox>
  );
};

export default TaskStepMetadata;
